var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    {
      staticClass: "c-page__main c-page__main--ugc c-post__page",
      attrs: { role: "main" },
    },
    [
      _c(
        "div",
        { staticClass: "o-wrapper" },
        [
          _c("div", { staticClass: "c-post__back--wrapper" }, [
            _c(
              "a",
              {
                ref: "community-back",
                staticClass: "c-post__back",
                attrs: { href: "/" + _vm.post.community_url },
              },
              [
                _c("img", {
                  attrs: {
                    src: "/img/ui/back-arrow.svg",
                    alt: "Back Arrow",
                    width: "9",
                    height: "14",
                  },
                }),
                _vm._v(" "),
                _c("p", [_vm._v("Back")]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "article",
            {
              staticClass: "o-grid o-grid--center",
              attrs: { id: "post-view" },
            },
            [
              _c(
                "header",
                {
                  staticClass:
                    "c-post-click o-grid__item c-post__top u-width-8/12 u-p-t3 u-width-10/12@l u-width-full@m u-m-t2@m u-m-t0@s",
                },
                [
                  _c(
                    "div",
                    { ref: "articleHead", staticClass: "c-article__head" },
                    [
                      _c(
                        "div",
                        { ref: "communityLogo", staticClass: "c-article__img" },
                        [
                          _c(
                            "a",
                            { attrs: { href: "/" + _vm.post.community_url } },
                            [
                              _c("img", {
                                attrs: {
                                  src: _vm.$simpleStore.cloudinaryUrl(
                                    106,
                                    106,
                                    "img/communities/" +
                                      _vm.post.community_id +
                                      "/" +
                                      _vm.post.community_thumbnail,
                                    _vm.$root
                                  ),
                                  alt: _vm.post.community_name,
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          ref: "articleTitle",
                          class: [
                            "c-article__title",
                            "u-flex@m",
                            "u-flex-direction-column@m",
                            _vm.sticky ? "scroll" : "",
                          ],
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "c-article__posted u-order-2@m" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "u-hidden u-block@s",
                                  attrs: { href: "/" + _vm.post.community_url },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.$simpleStore.cloudinaryUrl(
                                        54,
                                        54,
                                        "img/communities/" +
                                          _vm.post.community_id +
                                          "/" +
                                          _vm.post.community_thumbnail,
                                        _vm.$root
                                      ),
                                      alt: _vm.post.community_name,
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "c-article__posted-by" },
                                [
                                  _vm.post.network_id ===
                                  _vm.$simpleStore.Networks.DY
                                    ? [
                                        _c("div", [
                                          _c("figure", { staticClass: "ugc" }, [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href:
                                                    "/u/" + _vm.post.username,
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "ugc__img",
                                                  attrs: {
                                                    src: _vm.post.user_avatar,
                                                    alt:
                                                      "Article Posted by " +
                                                      _vm.post.first_name +
                                                      " " +
                                                      _vm.post.surname,
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _c(
                                              "span",
                                              { staticClass: "u-bold" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "/u/" +
                                                        _vm.post.username,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.post.first_name
                                                      ) +
                                                        " " +
                                                        _vm._s(_vm.post.surname)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "u-normal" },
                                              [_vm._v("Posted to")]
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "c-article__posted-ugc",
                                            },
                                            [
                                              _c("span", [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        "/" +
                                                        _vm.post.community_url,
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.$simpleStore.cloudinaryUrl(
                                                          25,
                                                          25,
                                                          "img/communities/" +
                                                            _vm.post
                                                              .community_id +
                                                            "/" +
                                                            _vm.post
                                                              .community_thumbnail,
                                                          _vm.$root
                                                        ),
                                                        alt: _vm.post
                                                          .community_name,
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "u-bold" },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href:
                                                          "/" +
                                                          _vm.post
                                                            .community_url,
                                                        id: "article-community-name",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.post
                                                            .community_name
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "u-normal" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.post.birthday_long
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    : [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "c-article__postfrom",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-article__postfrom-inner",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "u-color-grey2 u-text-small u-bold u-normal@m",
                                                      },
                                                      [_vm._v("Post from")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      _vm.post.duplicates,
                                                      function (dupe) {
                                                        return typeof _vm.post
                                                          .duplicates !=
                                                          "undefined" &&
                                                          _vm.post.duplicates
                                                            .length > 0
                                                          ? _c("div", {
                                                              class:
                                                                _vm.getNetworkClasses(
                                                                  dupe.network_id
                                                                ),
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    _vm.getNetworkMarkup(
                                                                      dupe.network_id
                                                                    )
                                                                  ),
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.showNetworkPost(
                                                                      dupe.network_id,
                                                                      _vm.post
                                                                        .dyadey_id,
                                                                      dupe.post_id
                                                                    )
                                                                  },
                                                              },
                                                            })
                                                          : _c(
                                                              "div",
                                                              {
                                                                class: [
                                                                  "c-article__social",
                                                                  "active c-article__social--" +
                                                                    _vm.post.network_name.toLowerCase(),
                                                                ],
                                                              },
                                                              [
                                                                _c("p", [
                                                                  _c(
                                                                    "a",
                                                                    {
                                                                      attrs: {
                                                                        href:
                                                                          "/" +
                                                                          _vm
                                                                            .post
                                                                            .community_url +
                                                                          "/" +
                                                                          dupe.dyadey_id,
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm
                                                                            .post
                                                                            .network_name
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]),
                                                              ]
                                                            )
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "c-article__posted-non-ugc",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "c-article__posted-details",
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "u-semibold u-bold@m",
                                                            attrs: {
                                                              href:
                                                                "/" +
                                                                _vm.post
                                                                  .community_url,
                                                            },
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: _vm.$simpleStore.cloudinaryUrl(
                                                                  25,
                                                                  25,
                                                                  "img/communities/" +
                                                                    _vm.post
                                                                      .community_id +
                                                                    "/" +
                                                                    _vm.post
                                                                      .community_thumbnail,
                                                                  _vm.$root
                                                                ),
                                                                alt: _vm.post
                                                                  .community_name,
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                attrs: {
                                                                  id: "article-community-name",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.post
                                                                      .community_name
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "time",
                                                      {
                                                        attrs: {
                                                          datetime:
                                                            _vm.postBirthdayDatetime,
                                                          title:
                                                            _vm.postBirthdayDatetime,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.postBirthdayWords
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ],
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "aside",
                                {
                                  class: [
                                    "c-card__menu-cta",
                                    { open: _vm.showContextMenu },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.toggleContextMenu.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" ")]
                              ),
                              _vm._v(" "),
                              _vm.post.network_id ===
                              _vm.$simpleStore.Networks.DY
                                ? _c(
                                    "div",
                                    {
                                      class: [
                                        "c-article__menu-items",
                                        { open: _vm.showContextMenu },
                                      ],
                                    },
                                    [
                                      _c("ul", [
                                        _vm._m(0),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "post-copy-link",
                                              attrs: {
                                                href: "#",
                                                "data-link":
                                                  _vm.post.community_url +
                                                  "/" +
                                                  _vm.post.dyadey_id,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.copyLink.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v("Copy the URL "),
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.$simpleStore
                                                          .success,
                                                      expression:
                                                        "$simpleStore.success",
                                                    },
                                                  ],
                                                },
                                                [_vm._v("✅")]
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm.$root.user !== false &&
                                        _vm.post.user_id === _vm.$root.user.id
                                          ? _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.modalDeletePost(
                                                        _vm.post.post_id
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Delete Post")]
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.admin
                                          ? _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.auditPost()
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v("Audit Post "),
                                                  _c("em", [
                                                    _vm._v("(admin only)"),
                                                  ]),
                                                ]
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c(
                                            "a",
                                            {
                                              attrs: { href: "#" },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.toggleContextMenu.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Cancel")]
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      class: [
                                        "c-article__menu-items",
                                        { open: _vm.showContextMenu },
                                      ],
                                    },
                                    [
                                      _c("ul", [
                                        _c("li", [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "post-copy-link",
                                              attrs: {
                                                href: "#",
                                                "data-link":
                                                  _vm.post.community_url +
                                                  "/" +
                                                  _vm.post.dyadey_id,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.copyLink.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v("Copy the URL "),
                                              _c(
                                                "span",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.$simpleStore
                                                          .success,
                                                      expression:
                                                        "$simpleStore.success",
                                                    },
                                                  ],
                                                },
                                                [_vm._v("✅")]
                                              ),
                                            ]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href:
                                                  _vm.post.network_id !==
                                                  _vm.$simpleStore.Networks.IN
                                                    ? _vm.post.uri
                                                    : _vm.post.source,
                                                target: "_blank",
                                              },
                                            },
                                            [_vm._v("View Original Source")]
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _vm.admin
                                          ? _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.modalDeletePost(
                                                        _vm.post.post_id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v("Delete Post "),
                                                  _c("em", [
                                                    _vm._v("(admin only)"),
                                                  ]),
                                                ]
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c(
                                            "a",
                                            {
                                              attrs: { href: "#" },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.toggleContextMenu.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("Cancel")]
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "c-article__title--h1 u-order-1@m" },
                            [_c("h1", [_vm._v(_vm._s(_vm.postTitle))])]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("router-view"),
              _vm._v(" "),
              _vm.$root.user !== false
                ? _c("a", {
                    staticClass: "c-article__add",
                    attrs: { href: "/post/create/" + _vm.post.community_url },
                  })
                : _c("a", {
                    staticClass: "c-article__add",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.showMemberPanel()
                      },
                    },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _c("related-content"),
        ],
        1
      ),
      _vm._v(" "),
      _c("modal"),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showDeleteModal
          ? _c("div", { staticClass: "c-cards__menu--delete" }, [
              _c("div", { staticClass: "o-grid o-grid--center u-bg-white" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "o-grid__item u-width-full u-a-center u-p-y6 u-p-x6",
                  },
                  [
                    _vm.showDeleteDraft === false
                      ? [
                          _c(
                            "h4",
                            {
                              staticClass:
                                "u-color-blue u-text-24 u-semibold u-m-b2",
                            },
                            [_vm._v("Delete Post")]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "u-m-b3" }, [
                            _vm._v(
                              "Are you sure you want to delete this post?"
                            ),
                          ]),
                        ]
                      : [
                          _c(
                            "h4",
                            {
                              staticClass:
                                "u-color-blue u-text-24 u-semibold u-m-b2",
                            },
                            [_vm._v("Delete Draft")]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "u-m-b3" }, [
                            _vm._v(
                              "Are you sure you want to delete this post?"
                            ),
                          ]),
                        ],
                    _vm._v(" "),
                    _c("div", { staticClass: "u-flex u-flex-justify-center" }, [
                      _vm.$root.user !== false &&
                      _vm.post.user_id === _vm.$root.user.id
                        ? _c(
                            "button",
                            {
                              staticClass: "c-btn c-btn--red u-m-r3",
                              on: {
                                click: function ($event) {
                                  return _vm.deletePost()
                                },
                              },
                            },
                            [_vm._v("Yes delete my " + _vm._s(_vm.item))]
                          )
                        : _vm.admin === true
                        ? _c(
                            "button",
                            {
                              staticClass: "c-btn c-btn--red u-m-r3",
                              on: {
                                click: function ($event) {
                                  return _vm.deleteCommunityPost()
                                },
                              },
                            },
                            [_vm._v("Yes delete community post")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "c-btn c-btn--red is-outline",
                          on: { click: _vm.closeModal },
                        },
                        [_vm._v("Cancel")]
                      ),
                    ]),
                  ],
                  2
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.admin && _vm.showAuditPost
          ? _c("div", { staticClass: "c-cards__menu--delete" }, [
              _c("div", { staticClass: "o-grid o-grid--center u-bg-white" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "o-grid__item u-width-full u-a-center u-p-y6 u-p-x6",
                  },
                  [
                    _c(
                      "h4",
                      {
                        staticClass: "u-color-blue u-text-24 u-semibold u-m-b2",
                      },
                      [_vm._v("Audit Post")]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "u-m-b3" }, [
                      _vm._v("Classify post as appropriate below:"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "u-flex u-flex-justify-center" }, [
                      _c(
                        "button",
                        {
                          staticClass: "c-btn c-btn--red u-m-r3",
                          on: {
                            click: function ($event) {
                              return _vm.classifyPost("very good")
                            },
                          },
                        },
                        [_vm._v("Very Good")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "c-btn c-btn--red u-m-r3",
                          on: {
                            click: function ($event) {
                              return _vm.classifyPost("average")
                            },
                          },
                        },
                        [_vm._v("Average")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "c-btn c-btn--red u-m-r3",
                          on: {
                            click: function ($event) {
                              return _vm.classifyPost("bad")
                            },
                          },
                        },
                        [_vm._v("Bad")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "c-btn c-btn--red u-m-r3",
                          on: {
                            click: function ($event) {
                              return _vm.classifyPost("inappropriate")
                            },
                          },
                        },
                        [_vm._v("Inappropriate")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "c-btn c-btn--red is-outline",
                          on: { click: _vm.closeModal },
                        },
                        [_vm._v("Cancel")]
                      ),
                    ]),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [_c("a", { attrs: { href: "#" } }, [_vm._v("Share")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }